export const NO_OP = (): void => undefined;
